
import { supabase } from '@/integrations/supabase/client';

/**
 * Check if user is a company admin using profiles table
 */
export const isCompanyAdmin = async (userId: string, companyId: string): Promise<boolean> => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('role')
      .eq('id', userId)
      .eq('company_id', companyId)
      .eq('role', 'admin')
      .maybeSingle();
    
    if (error) throw error;
    return !!data;
  } catch (error) {
    console.error('Error checking if user is company admin:', error);
    return false;
  }
};

/**
 * Get members for a specific company from profiles table
 */
export const getCompanyMembers = async (companyId: string): Promise<any[]> => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('id, first_name, last_name, email, avatar_url, role')
      .eq('company_id', companyId);
    
    if (error) throw error;
    
    return data.map(user => ({
      ...user,
      companyRole: user.role // Map the role to companyRole for backward compatibility
    }));
  } catch (error) {
    console.error('Error fetching company members:', error);
    return [];
  }
};

/**
 * Request access to a company
 */
export const requestCompanyAccess = async (userId: string, companyId: string, notes?: string): Promise<boolean> => {
  try {
    // Update the user's profile with the requested company
    const { error: profileError } = await supabase
      .from('profiles')
      .update({ requested_company_id: companyId })
      .eq('id', userId);
    
    if (profileError) throw profileError;
    
    // Create the access request
    const { error: requestError } = await supabase
      .from('company_access_requests')
      .insert({
        user_id: userId,
        company_id: companyId,
        notes: notes || 'Access requested'
      });
    
    if (requestError) throw requestError;
    
    return true;
  } catch (error) {
    console.error('Error requesting company access:', error);
    return false;
  }
};
